import ExpandMore from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';
import { ReactNode, useId, useState } from 'react';
import {
	PageSectionActions,
	PageSectionHeader,
	PageSectionHeading,
	PageSectionToggle,
} from 'shared/_components/page-section/styles';

type PageSectionProps = {
	title: ReactNode;
	/** Right-aligned header actions (e.g. the add button and a menu). */
	actions?: ReactNode;
	children: ReactNode;
	defaultCollapsed?: boolean;
};

/** Collapsible page section: centered display-font title that toggles the content, actions on the right. */
export default function PageSection({
	title,
	actions,
	children,
	defaultCollapsed = false,
}: PageSectionProps) {
	const contentId = useId();
	const [collapsed, setCollapsed] = useState(defaultCollapsed);

	return (
		<section>
			<PageSectionHeader>
				<PageSectionHeading>
					<PageSectionToggle
						aria-expanded={!collapsed}
						aria-controls={contentId}
						onClick={() => setCollapsed((value) => !value)}
					>
						<Typography noWrap variant="h1" component="span">
							{title}
						</Typography>
						<ExpandMore />
					</PageSectionToggle>
				</PageSectionHeading>
				{!!actions && <PageSectionActions>{actions}</PageSectionActions>}
			</PageSectionHeader>
			<div id={contentId} hidden={collapsed}>
				{children}
			</div>
		</section>
	);
}
